import { render } from "./QAndACommentsList.vue?vue&type=template&id=2d93b564"
import script from "./QAndACommentsList.vue?vue&type=script&lang=js"
export * from "./QAndACommentsList.vue?vue&type=script&lang=js"

import "./QAndACommentsList.vue?vue&type=style&index=0&id=2d93b564&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__